import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Controller, Autoplay, Thumbs } from 'swiper/core';
import $ from 'jquery';

class ImageSlideshow {
	constructor() {
		this.init();
	}

	init() {
		SwiperCore.use([Navigation, Pagination, Controller, Autoplay, Thumbs]);

		const breakpoint = window.matchMedia('(min-width:31.25em)');

		var mySwipers = null;

		const breakpointChecker = function () {
			if (mySwipers && breakpoint.matches === true) {
				mySwipers.forEach((swiper) => {
					console.log(swiper);
					if (swiper !== undefined) swiper.destroy(true, true);
				});
				return;
			} else if (breakpoint.matches === false) {
				return enableSwiper();
			}
		};

		const enableSwiper = function () {
			mySwipers = new Array();

			$('.team-container').each(function (e) {
				var main = $(this).find('.swiper-container').get(0);

				var swiper = new Swiper(main, {
					spaceBetween: 10,
					centeredSlides: false,
					loop: false,
					direction: 'horizontal',
					loopedSlides: 5,
					pagination: {
						el: '.swiper-pagination',
						type: 'bullets',
						clickable: true
					},
					resizeObserver: true,
				});

				mySwipers.push(swiper);
			});
		};

		breakpoint.addListener(breakpointChecker);
		breakpointChecker();
	}
}

export default ImageSlideshow;
